import Calculations from './calculations'

export const handleInputCalculations = (
  sliderValue: any,
  rollUnder: string,
  rake: string,
  bankroll: string,
  stake: string,
  handleMultiplier: (s: string) => void,
  handleFinalStake: (s: string) => void,
  handleChance: (s: string) => void,
) => {
  const { payout, profit, winchance } = Calculations(
    sliderValue,
    rollUnder,
    rake,
    bankroll,
    stake,
  )
  handleMultiplier(payout as string)
  handleFinalStake(profit.toString())
  handleChance(winchance.toString())
}
